var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"outlined":"","label":"Select domain","items":_vm.list,"item-text":"name","item-value":"name"},model:{value:(_vm.domain),callback:function ($$v) {_vm.domain=$$v},expression:"domain"}})}
var staticRenderFns = []

export { render, staticRenderFns }